module.exports = __webpack_public_path__ + "stylesheets/wave-projects_5db773f974b16809893bd52ae484c682.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-projects.less
// module id = 15vf
// module chunks = 154